export const isProduction = (): boolean => {
  const currentDomain = window.location.hostname;
  return currentDomain === "app.wayvee.com";
};
